<!-- Redeem.vue -->
<template>
    <div id="redeem-wrap">
        <div id="redeem">
            <h2>Activate Your Product</h2>
            <p>Enter your redeem code below to activate the product on your account. Each code is unique and can be used only once.</p><br><br>
            <p><strong>Example Code:</strong> WM1OK-FESA8-T7ESV-MB0XW-Q0IAZ</p><br><br>
            
            <form @submit.prevent="redeem">
                <Input type="text" label="Redeem Code" v-model="redeem_code" name="redeemcode" additional="checkmark"/>
                <input type="submit" class="fa-btn fa-btn-primary fa-btn-modal" :disabled="isButtonDisabled" value="Redeem">
                
                <ModalMessage :message="userFeedbackMessage" :type="userFeedbackMessageType"/>

                <p v-if="countdown > 0" class="countdown-message">
                    The window will close automatically in {{ countdown }} seconds.
                </p>

                <p class="redeem-hint">
                    Note: A redeem code is linked to your account/email once used and cannot be reused.
                </p>
            </form>  
        </div>
    </div>
</template>
  
  <script setup lang="ts">
import { useUIStore } from '@/store/uiStore';
import { ref, computed, onBeforeMount, onUnmounted } from 'vue';
import { ModalTypes, MessageType } from '@/types/enums';
import APIClient from '~/api/apiClient';
import { useUserStore } from '~/store/userStore';
import { CSRFType } from '@/api/apiClient';
import CSRFManager from '~/utils/csrfManager.ts';
    
const uiStore = useUIStore();
const userStore = useUserStore();
const apiClient = APIClient.getInstance();
const wasRedeemedSuccessful = ref(false);
const redeem_code = ref("");
const userFeedbackMessage = ref("");
const userFeedbackMessageType = ref(MessageType.INFO);
const csrfManager = new CSRFManager(CSRFType.REDEEM_PRODUCT);
const csrfToken = computed(() => csrfManager.state.csrfToken);
const countdown = ref(0);
const isButtonDisabled = ref(false);
const isValidCode = ref(true);

  onBeforeMount(async () => {
    await csrfManager.startFetchingToken();
  });
  
  onUnmounted(() => {
    csrfManager.stopFetchingToken();
    if (wasRedeemedSuccessful.value) {
        console.log("Redeem Successful, reloading page");
        window.location.reload();
    }
  });
  
   const validateCode = () => {
        const pattern = /^[A-Z0-9]{5}-[A-Z0-9]{5}-[A-Z0-9]{5}-[A-Z0-9]{5}-[A-Z0-9]{5}$/;
        isValidCode.value = pattern.test(redeem_code.value);
    };

  const redeem = async () => {

    validateCode();
    if (!isValidCode.value) {
        userFeedbackMessageType.value = MessageType.ERROR;
        userFeedbackMessage.value = "Invalid redeem code format. Please make sure you have a valid code and the copy & paste was correct.";
        return;
    }

    const response = await apiClient.redeemProduct(csrfToken.value, redeem_code.value);
    console.log("adf redeem", response, "csrfToken", csrfToken.value);
    csrfManager.fetchToken();
    if(response.valid) {
        userFeedbackMessageType.value = MessageType.SUCCESS;
        userFeedbackMessage.value = "The product was successfully redeemed. You can close the window now.";
        await userStore.fetchUserProducts();
        wasRedeemedSuccessful.value = true;

        countdown.value = 30;
        isButtonDisabled.value = true;
        const intervalId = setInterval(() => {
            countdown.value--;
            if (countdown.value === 0) {
                clearInterval(intervalId);
                uiStore.setModalType(ModalTypes.INACTIVE);
                console.log("Redeem Successful, 30 seconds close time over, reloading page");
                window.location.reload();
            }
        }, 1000);
    }
    else
    {
        userFeedbackMessageType.value = MessageType.ERROR;        
        if(response.code == 406)
        {
            userFeedbackMessage.value = "The entered redeem code was already used.";
        }
        else
        {
            userFeedbackMessage.value = response.error;
        }
    }
  }  
  </script>
  
  <style lang="scss" scoped>
  @import '~/assets/constants.scss';

  .redeem-hint {
    font-style: italic;
    font-size: 0.75rem;
    margin-top: 0.5rem;
  }

  .countdown-message {
    margin-top: 0.5rem;
    font-weight: bold;
    color: $fa-green; /* Example color, adjust as needed */
}

  </style>